import { useEffect, useState } from "react";

import classNames from "classnames";
import { format } from "date-fns";
import download from "downloadjs";
import { addLocale, locale } from "primereact/api";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { FaCalendarAlt, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { mask } from "remask";
import AppCard from "../../../../components/appCard";
import { Api, ApiAdimplencia } from "../../../../services/api";
import { CalendarPague, DropdownPague } from "../../../../styles/primeReactConfig";
import Base64ToPDF from "../../../../utils/Base64ToPDF";
import { formatCurrency } from "../../../../utils/formatCurrency";
import GeraXLSX from "../../../../utils/GeraXLSX";

export default function Relatorios({ }) {
  const { type } = useParams();
  const [diaInicial, setDiaInicial] = useState();
  const [diaFinal, setDiaFinal] = useState();
  const [mobile, setMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('Todos');
  const [tipo, setTipo] = useState('')

  const [typeSearch, setTypeSearch] = useState("todos");

  const [filterOptions] = useState([
    { label: 'Todos', value: 'todos' },
    { label: 'Cancelado', value: 'cancelado' },
    { label: 'Confirmado', value: 'confirmado' },
    { label: 'Enviado', value: 'enviado' },
    { label: 'Pago', value: 'pago' },
    { label: 'Protestado', value: 'protestado' },
    { label: 'Protesto Manual', value: 'protestoM' },
    { label: 'Retirado', value: 'retirado' },
    { label: 'Devolvido', value: 'devolvido' }
  ]);

  useEffect(() => {
    ScreenCheck()
  }, [])

  const today = new Date();
  const minimo = new Date("2010-01-01T00:00:00");
  addLocale('pt-BR', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Claro'
  });
  locale('pt-BR');

  const statusOptionsAdimplencia = [
    { label: 'Pago', value: 'Pago' },
    { label: 'Vencido', value: 'Vencido' },
    { label: 'Aguardando', value: 'Aguardando' },
    { label: 'Todos', value: 'Todos' },
  ]

  const statusOptionsInadimplencia = [
    { label: 'Todos', value: 'Todos' },
    { label: 'Processamento', value: 'Processamento' },
    { label: 'Pago no Cartório', value: 'Pago pós Protesto' },
    { label: 'Pago', value: 'Pago' },
  ]

  const ScreenCheck = () => {
    if (window.screen.width < 480 || window.screen.height < 480) {
      setMobile(true)
    }
    else {
      setMobile(false)
    }
  }

  const getLabel = (type) => {
    if (loading) return "Gerando..."
    if (type === 'PDF') return "PDF";
    else if (type === 'XLSX') return 'Excel'
  }

  function formataDataset(array) {
    const arrayFormatado = [];
    if (type === 'REP') {
      array.forEach((item) => {
        arrayFormatado.push({
          data_de_deposito: item.data_de_deposito,
          situacao: item.situacao,
          nome_do_cliente: item.nome_cliente,
          documento_cliente: mask(item.documento_cliente, ['999.999.999-99', '99.999.999/9999-99']),
          codigo_do_cliente: item.codigo_do_cliente,
          valor_liquido: Number(item.valor_liquido ? item.valor_liquido : '0'),
          parcelas: item.parcelas,
          valor_da_parcela: Number(item.valor_da_parcela ? item.valor_da_parcela : '0'),
          data_de_vencimento: item.data_de_vencimento,
          data_primeira_parcela: item.data_primeira_parcela,
          formapagamento: item.formapagamento,
          descricao: item.descricao,
          codigo_debito: item.codigo_debito
        })
      })
    }
    else if (type === 'ADI') {
      array.relatorio.forEach((item) => {
        arrayFormatado.push({
          contrato_numero: item.contrato_numero,
          boleto_situacao: item.boleto_situacao,
          usuario_nome: item.usuario_nome,
          usuario_documento: mask(item.usuario_documento, ['999.999.999-99', '99.999.999/9999-99']),
          faturamento_descricao: item.faturamento_descricao,
          boleto_vencimento: item.boleto_vencimento,
          boleto_data_pagamento: item.boleto_data_pagamento,
          data_repasse: item.data_repasse,
          faturamento_desconto: item.faturamento_desconto,
          boleto_valor: item.boleto_valor,
          boleto_valor_pago: item.boleto_valor_pago,
          valor_credor: item.valor_credor,
        })
      })
    }
    else if (type === 'PTR') {
      array.forEach((item) => {
        arrayFormatado.push({
          data_envio: item.data_envio,
          devedor: item.devedor,
          cpf: mask(item.cpf, ['999.999.999-99', '99.999.999/9999-99']),
          valor: Number(item.valor),
          descricao: item.descricao,
          vencimento: item.vencimento,
          protocolo: item.protocolo ? item.protocolo : '',
          comarca: item.comarca ? item.comarca : '',
          cartorio: item.cartorio ? item.cartorio : '',
          status_atual: item.status_atual
        })

      })
    } else if (type === 'BAI') {
      let totalValor = 0;
      array.forEach((item) => {
        arrayFormatado.push({
          data_baixa: item.data_da_baixa ? item.data_da_baixa : '',
          nome_cliente: item.cliente,
          doc_cliente: mask(item.doc_cliente, ['999.999.999-99', '99.999.999/9999-99']),
          cod_cliente: item.cod_cliente,
          descricao: item.cobranca_descricao,
          valor: Number(item.cobranca_valor),
          data_primeira_comunicacao: item.data_primeira_comunicacao
        })
        // Atualizando o total
        totalValor += Number(item.cobranca_valor);
      })
      // Adicionando uma linha para o total
      const totalRow = { data_baixa: 'Total:', valor: totalValor };
      arrayFormatado.push(totalRow);
    } else if (type === 'INA') {
      array.forEach((item) => {
        arrayFormatado.push({
          boleto_situacao: item.boleto_situacao,
          contrato_numero: item.contrato_numero,
          usuario_nome: item.usuario_nome,
          usuario_documento: mask(item.usuario_documento, ['999.999.999-99', '99.999.999/9999-99']),
          faturamento_descricao: item.faturamento_descricao,
          boleto_valor: formatCurrency(item.boleto_valor.replace(',', '.')),
          faturamento_desconto: formatCurrency(item.faturamento_desconto.replace(',', '.')),
          boleto_data_pagamento: item.boleto_data_pagamento ? item.boleto_data_pagamento : '',
          boleto_vencimento: item.boleto_vencimento,
          boleto_valor_pago: item.boleto_valor_pago ? formatCurrency(item.boleto_valor_pago.replace(',', '.')) : '',
          valor_credor: item.valor_credor ? item.valor_credor : '',
          data_repasse: item.data_repasse ? item.data_repasse : ''
        })
      })
    }

    return (arrayFormatado)
  }

  const GenerateINA = async (event) => {
    const formatInicial = format(diaInicial, "dd-MM-yyyy");
    const formatFinal = format(diaFinal, "dd-MM-yyyy");

    setLoading(true);
    event.preventDefault();
    try {
      if (tipo === 'PDF') {
        if (type === 'REP') {
          const response = await Api.get(`relatorio/repasse/${status}/${formatInicial}/${formatFinal}`, { responseType: 'blob' });
          download(response.data, `Relatorio_${formatInicial}_ate_${formatFinal}`);
        } else if (type === 'PTR') {
          const response = await Api.post(`relatorio/protestadosFiltro/${formatInicial}/${formatFinal}`, { campo_filtro: typeSearch }, { responseType: 'blob' });
          download(response.data, `Relatorio_${formatInicial}_ate_${formatFinal}`);
        } else if (type === 'BAI') {
          const response = await Api.get(`/relatorio/baixasprovider/${formatInicial}/${formatFinal}`);
          Base64ToPDF(response.data, `Relatorio_${formatInicial}_ate_${formatFinal}`);
        }

      } else if (tipo === 'XLSX') {
        //console.log('XLS')
        let response = [];
        if (type === 'REP') {
          const { data } = await Api.get(`relatorio/repasseCsv/${status}/${formatInicial}/${formatFinal}`);
          response = data
        } else if (type === 'PTR') {
          const { data } = await Api.get(`relatorio/protestadosCsv/${formatInicial}/${formatFinal}`, { params: { campo_filtro: typeSearch } });
          response = data
        } else if (type === 'BAI') {
          const { data } = await Api.get(`relatorio/baixasCsv/${formatInicial}/${formatFinal}`)
          response = data
        }

        baixarXLSX(formataDataset(response))
      }
    } catch (error) {
      // console.log('GenerateINA', error);
      console.error(error);
      if (error.response === undefined)
        return toast.error('Erro de comunicação com o servidor');
      if (error.response.status === 403 && type === 'BAI')
        return toast.warn('Nenhuma baixa encontrada para este período de tempo');
      if (error.response.status === 500)
        return toast.error('Erro interno de servidor');
      if (!error.response)
        return toast.error('Erro de comunicação com o servidor');
    } finally {
      setLoading(false);
    }
  }

  const generateADI = async (event) => {
    event.preventDefault();
    setLoading(true)
    const formatInicial = format(diaInicial, "yyyy-MM-dd");
    const formatFinal = format(diaFinal, "yyyy-MM-dd");

    if (tipo === 'PDF') {
      const { data } = await ApiAdimplencia.get(`/relatorio/adimplencia/${status}/${formatInicial}/${formatFinal}/pdf`, { responseType: 'blob' })

      download(data, `Relatorio_${formatInicial}_ate_${formatFinal}`)
    } else {
      const { data } = await ApiAdimplencia.get(`/relatorio/adimplencia/${status}/${formatInicial}/${formatFinal}/xlsx`)
      baixarXLSX(formataDataset(data))
    }

    setLoading(false)
  }

  function baixarXLSX(data) {
    let nome_arquivo = ''
    let propsXLSX = []
    switch (type) {

      case 'REP':
        nome_arquivo = `Relatório_de_repasses_${format(new Date(), 'dd-MM-yyyy')}`
        propsXLSX = [
          { label: "Data de depósito", value: "data_de_deposito" },
          { label: "Situação", value: "situacao" },
          { label: "Nome do cliente", value: "nome_do_cliente" },
          { label: "Documento do cliente", value: "documento_cliente" },
          { label: "Código do cliente", value: "codigo_do_cliente" },
          { label: "Valor líquido", value: "valor_liquido" },
          { label: "Parcelas", value: "parcelas" },
          { label: "Valor da parcela", value: "valor_da_parcela" },
          { label: "Data de vencimento", value: "data_de_vencimento" },
          { label: "Data da primeira parcela", value: "data_primeira_parcela" },
          { label: "Forma de pagamento", value: "formapagamento" },
          { label: "Cobranças", value: "descricao" },
          { label: "Código do Débito", value: "codigo_debito" },
        ]
        break
      case 'PTR':
        nome_arquivo = `Relatório_de_protestados_${format(new Date(), 'dd-MM-yyyy')}`
        propsXLSX = [
          { label: "Data de envio", value: "data_envio" },
          { label: "Devedor", value: "devedor" },
          { label: "CPF", value: "cpf" },
          { label: "Valor", value: "valor" },
          { label: "Descrição", value: "descricao" },
          { label: "Vencimento", value: "vencimento" },
          { label: "Protocolo", value: "protocolo" },
          { label: "Comarca", value: "comarca" },
          { label: "Cartório", value: "cartorio" },
          { label: "Status atual", value: "status_atual" }]
        break
      case 'ADI':
        nome_arquivo = `relatorio_adimplencia_${status}`
        propsXLSX = [
          { label: "Contrato", value: "contrato_numero" },
          { label: "Situação", value: "boleto_situacao" },
          { label: "Cliente", value: "usuario_nome" },
          { label: "Documento", value: "usuario_documento" },
          { label: "Descrição", value: "faturamento_descricao" },
          { label: "Valor", value: "boleto_valor" },
          { label: "Desconto", value: "faturamento_desconto" },
          { label: "Vencimento", value: "boleto_vencimento" },
          { label: "Valor pago", value: "boleto_valor_pago" },
          { label: "Data de pagamento", value: "boleto_data_pagamento" },
          { label: "Repasse", value: "valor_credor" },
          { label: "Data de repasse", value: "data_repasse" }]
        break
      case 'BAI':
        nome_arquivo = `Relatório_de_baixas_${format(new Date(), 'dd-MM-yyyy')}`
        propsXLSX = [
          { label: "Data da baixa", value: "data_baixa" },
          { label: "Nome do cliente", value: "nome_cliente" },
          { label: "Documento", value: "doc_cliente" },
          { label: "Código do cliente", value: "cod_cliente" },
          { label: "Descrição", value: "descricao" },
          { label: "Valor", value: "valor" },
          { label: "Data primeira comunicação", value: "data_primeira_comunicacao" }]
        break
      default:
        toast.error('Erro ao gerar relatório')
    }
    let headers = propsXLSX.map(xlsx => xlsx.label)
    let fields = propsXLSX.map(xlsx => xlsx.value)

    const parametrosXLSX = {
      data: data,
      headers: headers,
      fields: fields,
      titulo: nome_arquivo
    }
    GeraXLSX(parametrosXLSX)
  }

  return (
    <div>
      
      {type === 'ADI' ? (
        <div className="custom-btn-excel ml-5 md:ml-0">
          <form onSubmit={(e) => generateADI(e)}>
            <div>
              <div className="flex" >
                <div className="w-11 md:w-5 ml-0 md:ml-4">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <Calendar
                        inputId="first"
                        value={diaInicial}
                        minDate={minimo}
                        locale="pt-BR"
                        dateFormat="dd/mm/yy"
                        onChange={(e) => {
                          if (e.value > diaFinal) setDiaFinal('')
                          setDiaInicial(e.value)
                        }}
                        yearRange="2010:2030"
                        yearNavigator
                        required
                      />
                      <label htmlFor="first">Dia Inicial</label>
                    </span>
                  </div>
                </div>
                <div className="w-11 md:w-5 mt-2 md:mt-0 ml-0 md:ml-4">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <Calendar
                        inputId="last"
                        value={diaFinal}
                        minDate={diaInicial}
                        locale="pt-BR"
                        dateFormat="dd/mm/yy"
                        onChange={(e) => setDiaFinal(e.value)}
                        yearRange="2010:2030"
                        yearNavigator
                        required
                      />
                      <label htmlFor="last">Dia Final</label>
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex -mt-2 md:mt-0">
                <div className="w-11 md:w-5 ml-0 md:ml-4">
                  <div className="p-inputgroup">
                    <Dropdown
                      pt={DropdownPague}
                      value={status}
                      options={statusOptionsAdimplencia}
                      onChange={e => setStatus(e.value)}
                    />
                  </div>
                </div>
                <div className="w-11 md:w-5 mt-2 md:mt-0 ml-0 md:ml-4">
                  <div className="p-inputgroup">
                    <Button
                      className="mr-1"
                      severity="success"
                      loading={loading}
                      icon="pi pi-file-excel"
                      iconPos="left"
                      onClick={() => setTipo('XLSX')}
                      label={getLabel('XLSX')}
                      type="submit"
                      style={{ width: '49%' }}
                    />
                    <Button
                      severity="danger"
                      className="ml-1"
                      loading={loading}
                      icon="pi pi-file-pdf"
                      iconPos="left"
                      onClick={() => setTipo('PDF')}
                      label={getLabel('PDF')}
                      type="submit"
                      style={{ width: '49%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div>
          <AppCard>
            <form onSubmit={(e) => GenerateINA(e)}>
              <div className="grid w-full gap-4">
                <div className="px-2">
                  {type === "REP" ?
                    (<h4 className="text-xl"><b>Relatório de Repasses</b></h4>) :
                    type === 'PTR' ? (
                      (<h4 className="text-xl"><b>Relatório de Títulos Enviados a Protesto</b></h4>)
                    ) : (
                      <h4 className="text-xl"><b>Relatório de Baixas</b></h4>
                    )
                  }
                  <h6>Informe o período do Relatório</h6>
                </div>
                <div className="grid md:flex w-full items-end" >
                  <div className="grid w-full md:w-1/3 p-2" >
                    <label htmlFor="first">Dia Inicial</label>
                    <Calendar
                      inputId="first"
                      value={diaInicial}
                      pt={CalendarPague}
                      minDate={minimo}
                      maxDate={today}
                      locale="pt-BR"
                      dateFormat="dd/mm/yy"
                      mask="99/99/9999"
                      showIcon
                      showOnFocus={false}
                      icon={<FaCalendarAlt className={
                        classNames('px-4 rounded-r-lg',
                          'w-[50px] h-full',
                          'bg-sky-400 text-white hover:bg-sky-500',
                          'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                        )} 
                      />}
                      onChange={(e) => setDiaInicial(e.value)}
                      yearRange="2010:2030"
                      yearNavigator
                      required
                    />
                  </div>
                  <div className="grid w-full md:w-1/3 p-2" >
                    <label htmlFor="last">Dia Final</label>
                    <Calendar
                      inputId="last"
                      value={diaFinal}
                      pt={CalendarPague}
                      minDate={diaInicial}
                      maxDate={today}
                      locale="pt-BR"
                      dateFormat="dd/mm/yy"
                      showIcon
                      mask="99/99/9999"
                      showOnFocus={false}
                      icon={<FaCalendarAlt className={
                        classNames('px-4 rounded-r-lg',
                          'w-[50px] h-full',
                          'bg-sky-400 text-white hover:bg-sky-500',
                          'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                        )} 
                      />}
                      onChange={(e) => setDiaFinal(e.value)}
                      touchUI={mobile}
                      yearRange="2010:2030"
                      yearNavigator
                      required
                    />
                  </div>


                  {type === "PTR" &&
                    <div className="grid w-full md:w-1/3 p-2">
                      <Dropdown
                        // className="fit"
                        value={typeSearch}
                        pt={DropdownPague}
                        options={filterOptions}
                        onChange={(e) => {
                          setTypeSearch(e.value);
                        }}
                        style={{ marginTop: "1em", minWidth: "fit-content" }}
                      />
                    </div>}

                  {type === "REP" &&
                    <div className="w-full md:w-1/3 p-2">
                      <Dropdown
                        value={status}
                        pt={DropdownPague}
                        options={statusOptionsInadimplencia}
                        onChange={e => setStatus(e.value)}
                        style={{ marginTop: "1em" }} />
                    </div>}
                  {type === "ADI" &&
                    <div className="w-full md:w-1/3 p-2">
                      <Dropdown
                        value={status}
                        pt={DropdownPague}
                        options={statusOptionsAdimplencia}
                        onChange={e => setStatus(e.value)}
                        style={{ marginTop: "1em" }}
                      />
                    </div>}
                </div>

                <div className="flex w-full gap-4 md:w-1/2 px-2">
                  <Button
                    severity="danger"
                    className="w-full"
                    loading={loading}
                    icon={<FaFilePdf />}
                    iconPos="left"
                    label={getLabel('PDF')}
                    type="submit"
                    onClick={() => setTipo('PDF')}
                  />

                  <Button
                    severity="success"
                    className="w-full"
                    loading={loading}
                    icon={<FaFileExcel />}
                    iconPos="left"
                    label={getLabel('XLSX')}
                    type="submit"
                    onClick={() => setTipo('XLSX')}
                  />
                </div>
              </div>
            </form>
          </AppCard>
        </div>
      )}
    </div>
  )
}

